export default __webpack_public_path__ + "static/media/banner-bell.3884682e.svg";